import { render, staticRenderFns } from "./imageUpload.vue?vue&type=template&id=52b78084&scoped=true"
import script from "./imageUpload.vue?vue&type=script&lang=js"
export * from "./imageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b78084",
  null
  
)

export default component.exports